import { Component, OnInit, Output, Input, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Message, ConfirmationService } from 'primeng/api';
import { GlobalService } from '../../../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../../../environments/environment';
import { UserGroupService } from '../../user-group.service';
import { UserGroup } from '../../models';

@Component({
  selector: 'app-list-user-group',
  templateUrl: './list-user-group.component.html',
  styleUrls: ['./list-user-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ConfirmationService, UserGroupService]
})

export class ListUserGroupComponent implements OnInit {

  @Output() doAddGroupEvent = new EventEmitter<boolean>();
  @Output() doEditGroupEvent = new EventEmitter<boolean>();
  @Output() selectedUserGroup = new EventEmitter<{}>();
  @Output() setBreadCrumbs = new EventEmitter<any[]>();
  @Output() existingGroupNames = new EventEmitter<any[]>();
  @Input() incomingMessage: {};

  userGroups: UserGroup[];
  message: Message[] = [];
  usersInGroup: [];
  showUsersDialog = false;
  userCount: number;
  loading = false;
  loggedInUserId: number;

  constructor(private confirmationService: ConfirmationService
    , private userGroupService: UserGroupService
    , private _global: GlobalService) { }

  ngOnInit() {
    /* ---- Load All User Groups --- */
    this.displayMessage(this.incomingMessage);
    this.loggedInUserId = this._global.find((<any>_GlobalNS).paths.PersonId);
    this.loading = true;
    this.userGroupService.find(true)
      .subscribe((userGroups: UserGroup[]) => {
        this.userGroups = (<any>userGroups).data;
        const groupNames = this.userGroups.map((groupItem) => (groupItem.PrivilegeGroup.GroupName).toLowerCase());
        this.existingGroupNames.emit(groupNames);
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.message = [{severity: 'error', summary: 'An error occurred while loading group.'}];
      });
  }

  emitAddEvent(displayDiv: boolean): void {
    this.doAddGroupEvent.emit(true);
  }

  emitEditEvent(displayDiv: boolean, userGroup: UserGroup['PrivilegeGroup']): void {
    this.doEditGroupEvent.emit(true);
    this.selectedUserGroup.emit(userGroup);
  }

  displayUsersDialog(users): void {
    this.usersInGroup = users;
    this.showUsersDialog = true;
  }

  displayMessage(objMessage): void {
    if (objMessage) {
      this.message = [objMessage];
    }
  }

  deleteUserGroup(userGroup: UserGroup['PrivilegeGroup']): void {
    const arrCompanyGroupId = [];
    const postData = {};
    const message = `Are you sure you want to remove the User Group: ${userGroup.GroupName}`;
    this.confirmationService.confirm({
      message: message,
      accept: () => {
        this.loading = true;
        arrCompanyGroupId.push(userGroup.CompanyGroupId);
        postData['CompanyGroupId'] = arrCompanyGroupId;
        this.userGroupService.delete(postData)
          .subscribe((CompanyGroupId: any) => {
            this.loading = false;
            this.message = [{severity: 'info', summary: `Successfully deleted user group ${userGroup.GroupName}`}];
            this.userGroups = this.userGroups.filter( (groupItem) => groupItem.PrivilegeGroup.CompanyGroupId !== userGroup.CompanyGroupId );
            this.existingGroupNames.emit(this.userGroups);
          },
            error => {
              this.loading = false;
              this.message = [{severity: 'error', summary: 'An error occurred while deleting group.'}];
            });
      }
    });
  }

}